import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faShoppingBasket, faPhone, faLocationDot, faAt, faBook } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faFacebook, faTiktok, faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { useParams } from "react-router-dom";

import CopyButton from '../components/copybutton.js';

import PartnersLogo from '../images/negativ-partners.webp';
import Logo from '../images/negativ-main-logo.webp';

import '../css/footer.css';

import useDictionary from '../hooks/useDictionary';

export default function Footer() {

    const dictionary = useDictionary();
    const params = useParams();

    return (

        <div className="footer">
            
            <div className="footer-top-bar">
                <div className="footer-logo">
                    <img src={Logo} alt="Negativ" />
                </div>
            </div>

            <div className="footer-middle-bar">

                <div className="footer-menu-section">

                    <div className="footer-menu-items">
                        <div className="footer-contact-data">
                            <div className="icon">
                                <FontAwesomeIcon icon={faLocationDot} />
                            </div>
                            <div>
                                <ul>
                                    <li><strong>NEGATIV BRAND</strong></li>
                                    <li>GRUPA WECON</li>
                                    <li>95-015 Głowno</li>
                                    <li>ul. Dworska 27A</li>
                                    <li>{dictionary.POLAND}</li>
                                </ul>
                            </div>
                        </div>
                            
                        <div className="footer-contact-data">
                            <div className="icon">
                                <FontAwesomeIcon icon={faPhone} />
                            </div>
                            <div>
                                <ul>
                                    <li>{dictionary.HOTLINE}</li>
                                    <li>{dictionary.WORKING_HOURS} 9:00 - 16:00</li>
                                    <li><a href="tel:48222442245">(+48) <strong>222 44 22 45</strong></a></li>
                                </ul>
                            </div>
                        </div>
                            
                        <div className="footer-contact-data">
                            <div className="icon">
                                <FontAwesomeIcon icon={faAt} />
                            </div>
                            <div>
                                <ul>
                                    <li>{dictionary.CUSTOMER_SERVICE}</li>
                                    <li><CopyButton tekst="info@negativbrand.com" /></li>
                                </ul>
                            </div>
                        </div>

                        
                    </div>

                </div>

                <div className="footer-menu-section">

                    <div className="footer-menu-header">
                        {dictionary.OFFER}
                    </div>

                    <div className="footer-menu-items">
                        <ul>
                            <li><a href={`/${params.lang}/store`}><FontAwesomeIcon icon={faShoppingBasket} className="footer-icons" /> {dictionary.OFFICIAL_STORE}</a></li>
                            <li><a href={`/${params.lang}/catsuits`}>{dictionary.BEST_OVERALLS}</a></li>
                            <li><a href={`/${params.lang}/leggings`}>{dictionary.BEST_LEGGINGS}</a></li>
                            <li><a href={`/${params.lang}/leather-jackets`}>{dictionary.BEST_LEATHER_JACKETS}</a></li>
                            <li><a href={`/${params.lang}/giftcards`}>{dictionary.GIFT_CARDS}</a></li>
                            <li><a href={`/${params.lang}/customer`}>{dictionary.NEGATIV_ACCOUNT}</a></li>
                        </ul>
                    </div>

                </div>





                <div className="footer-menu-section">

                    <div className="footer-menu-header">
                        {dictionary.INFO}
                    </div>

                    <div className="footer-menu-items">
                        <ul>
                            <li><a href={`/${params.lang}/returns`}>{dictionary.RETURNS_AND_EXCHANGES}</a></li>
                            <li><a href={`/${params.lang}/delivery`}>{dictionary.DELIVERY_INFO}</a></li>
                            <li><a href={`/${params.lang}/sms-service`}>{dictionary.SMS_NOTIFY}</a></li>
                            <li><a href={`/${params.lang}/b2b-reg-form`}><FontAwesomeIcon icon={faBook} className="footer-icons" /> {dictionary.DISTRIBUTION}</a></li>
                            <li><a href={`/${params.lang}/b2b-platform`}>{dictionary.B2B_ACCESS}</a></li>
                            <li><a href={`/${params.lang}/contact`}><FontAwesomeIcon icon={faPhone} className="footer-icons" /> {dictionary.CONTACT_WITH_US}</a></li>
                        </ul>
                    </div>

                </div>


                <div className="footer-menu-section">

                    <div className="footer-menu-header">
                        {dictionary.LEGAL}
                    </div>

                    <div className="footer-menu-items">
                        <ul>
                            <li><a href={`/${params.lang}/terms-and-conditions`}>{dictionary.TERMS_AND_CONDITIONS}</a></li>
                            <li><a href={`/${params.lang}/rodo`}>RODO</a></li>
                            <li><a href={`/${params.lang}/cookies`}>{dictionary.PRIVACYPOLICY}</a></li>
                        </ul>
                    </div>

                </div>



            </div>

            <div className="footer-bottom-bar">
                <div className="footer-partners">
                    <div className="love-new-friends">
                        <div>We love <FontAwesomeIcon icon={faHeart} style={{color: '#c9a84c'}} /> new friends!</div>
                        <div className="social-media-icons">
                            <a href="https://www.facebook.com/NegativFashion/"><FontAwesomeIcon icon={faFacebook} style={{ color: '#66E'  }} /></a> 
                            <a href="https://www.instagram.com/negativ_official/"><FontAwesomeIcon icon={faInstagram} style={{ color: '#FF0069' }} /></a> 
                            <a href="https://www.tiktok.com/@negativofficial/"><FontAwesomeIcon icon={faTiktok} style={{ color: '#FFF' }} /></a>
                            <a href="https://wa.me/48792707070/" target="_whatsapp"><FontAwesomeIcon icon={faWhatsapp} style={{ color: '#3E3' }} /></a>
                        </div>
                    </div>
                    <div className="partners">
                        <img src={PartnersLogo} alt="Partners" />
                    </div>
                </div>

                <div className="footer-disclaimer">
                    <ul>
                        <li>{dictionary.TRADEMARK}</li>
                        <li>{dictionary.PROTECTEDDESIGN}</li>
                        <li>{dictionary.COOKIEACCEPTINFO}</li>
                        <li>{dictionary.WECONGROUP}</li>
                        <li>{dictionary.ALIASES}: <a href="https://www.negativ.fashion">www.negativ.fashion</a> <a href="https://www.negativbrand.com">www.negativbrand.com</a> <a href="https://www.negativ.pl">www.negativ.pl</a> <a href="https://www.negativ.com.pl">www.negativ.com.pl</a> <a href="https://www.ngv.com.pl">www.ngv.com.pl</a></li>
                    </ul>
                </div>
            </div>

        </div>

    )

}
